const safetyItems = [
  {
    problem: 'Nieuczciwy sprzedawca',
    risk: 'Średni',
    solution: 'Zawsze sprawdzaj oceny i historię sprzedawcy przed dokonaniem zakupu.',
  },
  {
    problem: 'Produkt niezgodny z opisem',
    risk: 'Niski (przy użyciu Spreadsheet)',
    solution: 'Dokładnie analizuj zdjęcia QC przed zatwierdzeniem wysyłki.',
  },
  {
    problem: 'Fałszywe linki',
    risk: 'Niski',
    solution: 'Korzystaj wyłącznie ze sprawdzonych linków z arkusza Kakobuy Spreadsheet.',
  },
  {
    problem: 'Bezpieczeństwo danych',
    risk: 'Niski',
    solution: 'Nigdy nie udostępniaj danych logowania, używaj silnych, unikalnych haseł.',
  },
  {
    problem: 'Bezpieczeństwo płatności',
    risk: 'Niski',
    solution: 'Korzystaj wyłącznie z oficjalnych metod płatności oferowanych przez platformę.',
  },
  {
    problem: 'Ryzyko związane z wysyłką',
    risk: 'Niski',
    solution: 'Wybieraj sprawdzone metody dostawy i śledź przesyłkę na bieżąco.',
  },
];

export default function SafetySection() {
  return (
    <section id="bezpieczenstwo" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-5">
            <i className="ri-shield-check-line text-2xl text-accent-600"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Jak korzystać z Kakobuy bezpiecznie?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Poznaj potencjalne zagrożenia i dowiedz się, jak skutecznie ich unikać podczas zakupów
          </p>
        </div>

        <div className="max-w-4xl mx-auto overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="border-b-2 border-background-300/60">
                <th className="text-left py-4 px-6 font-semibold text-foreground-900">Potencjalny problem</th>
                <th className="text-left py-4 px-6 font-semibold text-foreground-900 whitespace-nowrap">Ryzyko</th>
                <th className="text-left py-4 px-6 font-semibold text-foreground-900">Rozwiązanie</th>
              </tr>
            </thead>
            <tbody>
              {safetyItems.map((item, i) => (
                <tr key={i} className="border-b border-background-200/70">
                  <td className="py-4 px-6 text-foreground-800 font-medium">{item.problem}</td>
                  <td className="py-4 px-6 whitespace-nowrap">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium ${
                      item.risk === 'Niski' ? 'bg-accent-100 text-accent-700' :
                      item.risk === 'Średni' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-red-100 text-red-700'
                    }`}>
                      {item.risk}
                    </span>
                  </td>
                  <td className="py-4 px-6 text-foreground-600">{item.solution}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}